import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { atom, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';

export const navStateAtom = atom({
  isSticky: false,
  isNavVisible: true,
  isDropdownOpen: false,
  preventPeekaBoo: false,
  secondaryNav: false,
});

export const useStickyHeader = () => {
  const setNavState = useSetAtom(navStateAtom);

  const handleScroll = useDebouncedCallback(() => {
    const position = window.scrollY;
    setNavState((state) => {
      // Sticky offset when secondary nav is present must be larger to trigger when at top of page
      const stickyOffset = state.secondaryNav === true ? 300 : 30;
      return {
        ...state,
        isSticky: position > stickyOffset,
      };
    });
  }, 1);

  useScrollPosition(({ prevPos, currPos }) => {
    // Always keep nav visible for truly sticky behavior
    setNavState((state) => ({
      ...state,
      isNavVisible: true,
    })); 
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
};
